import {Client4} from 'mattermost-redux/client';

const PER_PAGE_DEFAULT = 60;
const FormData = require('form-data');

export default class CustomClientClass4 {

    createUserWithOauth = async (user, data, accessToken, inviteId, service, action) => {
        Client4.trackEvent('api', 'api_users_create');

        const queryParams = {};

        if (data) {
            queryParams.d = data;
        }

        if (accessToken) {
            queryParams.at = accessToken;
        }

        if (inviteId) {
            queryParams.iid = inviteId;
        }

        if (action) {
            queryParams.a = action;
        }

        return Client4.doFetch(
            `${Client4.getUsersRoute()}/create/${service}${buildQueryString(queryParams)}`,
            {method: 'post', body: JSON.stringify(user)}
        );
    };

    customOauthLogin = async (userId, accessToken, service, action, deviceId = '', ldapOnly = false) => {
        Client4.trackEvent('api', 'api_users_login');

        if (ldapOnly) {
            Client4.trackEvent('api', 'api_users_login_ldap');
        }

        const body = {
            device_id: deviceId,
            user_id: userId,
            access_token: accessToken,
            action: action
        };

        if (ldapOnly) {
            body.ldap_only = 'true';
        }

        const {headers, data} = await Client4.doFetchWithResponse(
            `${Client4.getUsersRoute()}/login/${service}`,
            {method: 'post', body: JSON.stringify(body)}
        );

        if (headers.has(Client4.HEADER_TOKEN)) {
            Client4.token = headers.get(Client4.HEADER_TOKEN);
        }

        return data;
    };

    updateSelfDestructTimer = async (channelId, patch) => {
        Client4.trackEvent('api', 'api_channels_patch', {channel_id: channelId});

        return Client4.doFetch(
            `${Client4.getChannelRoute(channelId)}/self_destruct_timer`,
            {method: 'put', body: JSON.stringify(patch)}
        );
    };

    batchUpdateSelfDestructTimer = async (selfDestructProps) => {

        Client4.trackEvent('api', 'api_channels_batch_update_selfDestructTimer', selfDestructProps);

        return Client4.doFetch(
            `${Client4.getUserRoute('me')}/self_destruct_timer`,
            {method: 'put', body: JSON.stringify(selfDestructProps)}
        );
    };
    
    initTalk2Site = async (channelId) => {
        return Client4.doFetch(
            `${Client4.getChannelRoute(channelId)}/inittalk2site`,
            {method: 'put'}
        );
    };

    getUnreadPosts = async (userId, teamId = '', page = 0, perPage = PER_PAGE_DEFAULT) => {
        Client4.trackEvent('api', 'api_posts_get_unread', {team_id: teamId});

        return Client4.doFetch(
            `${Client4.getUserRoute(userId)}/posts/unread${buildQueryString({team_id: teamId, page, per_page: perPage})}`,
            {method: 'get'}
        );
    };
    
    getVcLives = async (userId) => {
        return Client4.doFetch(
            `${Client4.getUrlVersion()}/vclog/livestream/${userId}`,
            {method: 'get'}
        );
    };
    
    getVcLivesPost = async (userId) => {
        return Client4.doFetch(
            `${Client4.getUrlVersion()}/vclog/livestreampost/${userId}`,
            {method: 'get'}
        );
    };

    searchXTeamPosts = async (teamId, terms, isOrSearch) => {
        Client4.trackEvent('api', 'api_posts_search', {team_id: teamId});

        return Client4.doFetch(
            `${Client4.getTeamRoute(teamId)}/posts/searchxteam`,
            {method: 'post', body: JSON.stringify({terms, is_or_search: isOrSearch})}
        );
    };
    
    exportTeam = async (teamId) => {
        Client4.trackEvent('api', 'api_teams_export', {team_id: teamId});

        return Client4.doFetch(
            `${Client4.getTeamRoute(teamId)}/export`,
            {method: 'get'}
        );
    };
    
    getTeamStorage = async (teamId) => {
        Client4.trackEvent('api', 'api_teams_getStorage', {team_id: teamId});

        return Client4.doFetch(
            `${Client4.getTeamRoute(teamId)}/storage`,
            {method: 'get'}
        );
    };
    
    getTeamVcHour = async (teamId) => {
        Client4.trackEvent('api', 'api_teams_getVcHour', {team_id: teamId});

        return Client4.doFetch(
            `${Client4.getTeamRoute(teamId)}/vchour`,
            {method: 'get'}
        );
    };
    
    exportTeamDownload = async (teamId,fileId) => {
        Client4.trackEvent('api', 'api_teams_export_download', {team_id: teamId,field_id: fileId});

        return Client4.doFetch(
                `${Client4.getTeamRoute(teamId)}/export/download/${fileId}`,
            {method: 'get'}
        );
    };
    
    getChannelsByIds = async (channelIds) => {
        Client4.trackEvent('api', 'api_channels_get_by_ids');

        return Client4.doFetch(
            `${Client4.getChannelsRoute()}/ids`,
            {method: 'post', body: JSON.stringify(channelIds)}
        );
    };

    uploadTeamImage = async (teamId, imageData) => {
        Client4.trackEvent('api', 'api_team_update_profile_picture');

        const formData = new FormData();
        formData.append('image', imageData);

        const request = {
            method: 'post',
            body: formData
        };

        if (formData.getBoundary) {
            request.headers = {
                'Content-Type': `multipart/form-data; boundary=${formData.getBoundary()}`
            };
        }

        return Client4.doFetch(
            `${Client4.getTeamRoute(teamId)}/image`,
            request
        );
    };

    uploadTeamBackgroundImage = async (teamId, imageData) => {

        const formData = new FormData();
        formData.append('image', imageData);

        const request = {
            method: 'post',
            body: formData
        };

        if (formData.getBoundary) {
            request.headers = {
                'Content-Type': `multipart/form-data; boundary=${formData.getBoundary()}`
            };
        }

        return Client4.doFetch(
            `${Client4.getTeamRoute(teamId)}/background`,
            request
        );
    };

    getMyAllChannels = async () => {
        return Client4.doFetch(
            `${Client4.getUserRoute('me')}/channels`,
            {method: 'get'}
        );
    };

    getMyAllMembers = async () => {
        return Client4.doFetch(
            `${Client4.getUserRoute('me')}/members`,
            {method: 'get'}
        );
    };
    
    getMyAllTeamUsers = async () => {
        return Client4.doFetch(
            `${Client4.getUserRoute('me')}/teams/member_users`,
            {method: 'get'}
        );
    };

    getQuotation = async(teamId, enquiry) => {
        Client4.trackEvent('api', 'api_get_quotation', {team_id: teamId});

        return Client4.doFetch(
            `${Client4.getTeamRoute(teamId)}/quotation`,
            {method: 'post', body: JSON.stringify(enquiry)}
        );
    }

    payByJetco = async(teamId, enquiry) => {
        Client4.trackEvent('api', 'api_pay_by_jetco', {team_id: teamId});

        return Client4.doFetch(
            `${Client4.getTeamRoute(teamId)}/payByJetco`,
            {method: 'post', body: JSON.stringify(enquiry)}
        );
    }

    payByAlipay = async(teamId, enquiry) => {
        Client4.trackEvent('api', 'api_pay_by_alipay', {team_id: teamId});

        return Client4.doFetch(
            `${Client4.getTeamRoute(teamId)}/payByAlipay`,
            {method: 'post', body: JSON.stringify(enquiry)}
        );
    }

    payByStripe = async(teamId, enquiry, token) => {
        Client4.trackEvent('api', 'api_pay_by_stripe', {team_id: teamId});

        return Client4.doFetch(
            `${Client4.getTeamRoute(teamId)}/payment/stripe`,
            {method: 'post', body: JSON.stringify({enquiry, token })}
        );
    }

    payZeroPayment = async(teamId, enquiry) => {
        // Client4.trackEvent('api', 'api_pay_zero_payment', {team_id: teamId});

        return Client4.doFetch (
            `${Client4.getTeamRoute(teamId)}/payment/zeroAmount`,
            {method: 'post', body: JSON.stringify(enquiry)}
        );
    }

    getContracts = async(teamId) => {
        Client4.trackEvent('api', 'api_get_contracts', {team_id: teamId});

        return Client4.doFetch(
            `${Client4.getTeamRoute(teamId)}/contract`,
            {method: 'get'}
        );
    }
    
    getInvitesByEmail = async(email) => {
        Client4.trackEvent('api', 'api_get_invites_by_email', {email: email});

        return Client4.doFetch(
            `${Client4.getUrlVersion()}/invitations/email/${(email)}`,
            {method: 'get'}
        );
    }

    getInvitesByUserId = async() => {
        return Client4.doFetch(
            `${Client4.getUrlVersion()}/invitations/users/me`,
            {method: 'get'}
        );
    }
    
    blockUser = async(sender) => {
        Client4.trackEvent('api', 'api_block_user', {sender: sender});

        return Client4.doFetch(
            `${Client4.getUserRoute('me')}/block/${(sender)}`,
            {method: 'put'}
        );
    }
    
    checkBlockUser = async(sender) => {
        Client4.trackEvent('api', 'api_check_block_user', {sender: sender});

        return Client4.doFetch(
            `${Client4.getUserRoute('me')}/block/${(sender)}`,
            {method: 'get'}
        );
    }
    
    unBlockUser = async(sender) => {
        Client4.trackEvent('api', 'api_unblock_user', {sender: sender});

        return Client4.doFetch(
            `${Client4.getUserRoute('me')}/unblock/${(sender)}`,
            {method: 'put'}
        );
    }
    
    getBlockList = async() => {
        Client4.trackEvent('api', 'api_get_block_list');

        return Client4.doFetch(
            `${Client4.getUserRoute('me')}/blocklist`,
            {method: 'get'}
        );
    }

    getOrderHist= async(teamId) => {
        Client4.trackEvent('api', 'api_getOrderHist', {team_id: teamId});

        return Client4.doFetch(
            `${Client4.getTeamRoute(teamId)}/orders`,
            {method: 'get'}
        );
    }

    getInvoice = async(orderId) => {
        Client4.trackEvent('api', 'api_getOrder', {order_id: orderId});

        return Client4.doFetch(
                `${Client4.getUrlVersion()}/invoice${buildQueryString({order_id: orderId,})}`,
            {method: 'get'}
        );
    }

    getBillingAddress = async(teamId) => {
        Client4.trackEvent('api', 'api_getBillingAddress', {team_id: teamId});

        return Client4.doFetch(
            `${Client4.getTeamRoute(teamId)}/billingAddress`,
            {method: 'get'}
        );
    }

    setBillingAddress = async(teamId, address) => {
        Client4.trackEvent('api', 'api_setBillingAddress', {team_id: teamId});

        return Client4.doFetch(
            `${Client4.getTeamRoute(teamId)}/billingAddress`,
            {method: 'post', body: JSON.stringify(address)}
        );

    }
    addMembersToChannel = async (channelId, userIds) => {
        // this.trackEvent('api', 'api_channels_batch_add_members', {channel_id: channelId, count: userIds.length});
        return Client4.doFetch(
            `${Client4.getChannelMembersRoute(channelId)}/batch`,
            {method: 'post', body: JSON.stringify(userIds)}
        );
    }
    addAllMembersToChannel = async (channelId) => {
        // this.trackEvent('api', 'api_channels_batch_add_members', {channel_id: channelId, count: userIds.length});
        return Client4.doFetch(
            `${Client4.getChannelMembersRoute(channelId)}/addall`,
            {method: 'post'}
        );
    }

    addGuestsToChannel = async (channelId, userIds) => {
        // this.trackEvent('api', 'api_channels_batch_add_members', {channel_id: channelId, count: userIds.length});
        return Client4.doFetch(
            `${Client4.getChannelMembersRoute(channelId)}/guest/batch`,
            {method: 'post', body: JSON.stringify(userIds)}
        );
    }
    addAllGuestsToChannel = async (channelId) => {
        // this.trackEvent('api', 'api_channels_batch_add_members', {channel_id: channelId, count: userIds.length});
        return Client4.doFetch(
            `${Client4.getChannelMembersRoute(channelId)}/guest/addall`,
            {method: 'post'}
        );
    };

    addAllUsersToTeam = async (teamId) => {
        return Client4.doFetch(
            `${Client4.getTeamMembersRoute(teamId)}/addall`,
            {method: 'post'}
        );
    };

    addGuestToTeam = async(teamId, userId) => {
        const member = {user_id: userId, team_id: teamId};
        return Client4.doFetch(
            `${Client4.getTeamMembersRoute(teamId)}/guest`,
            {method: 'post', body: JSON.stringify(member)}
        )

    };

    addGuestsToTeam =async(teamId, userIds) => {
        const members = [];
        userIds.forEach((id) => members.push({team_id: teamId, user_id: id}));
        return Client4.doFetch(
            `${Client4.getTeamMembersRoute(teamId)}/guest/batch`,
            {method: 'post', body: JSON.stringify(members)}
        );

    };

    addAllGuestsToTeam = async (teamId) => {
        return Client4.doFetch(
            `${Client4.getTeamMembersRoute(teamId)}/guest/addall`,
            {method: 'post'}
        );
    };

    getUserWithSensitiveInfo = async (userId) => {
        return Client4.doFetch(
            `${Client4.getUserRoute(userId)}${buildQueryString({sensitive: true})}`,
            {method: 'get'}
        );
    };

    getUserDefinedStatus = async (userId, udfStatusId) => {
        return Client4.doFetch(
            `${Client4.getUserRoute(userId)}/udf_status/${udfStatusId}`,
            {method: 'get'}
        );
    };

    getUserDefinedStatuses = async (userId) => {
        return Client4.doFetch(
            `${Client4.getUserRoute(userId)}/udf_statuses`,
            {method: 'get'}
        );
    };

    saveOrUpdateUserDefinedStatus = async (userId, udfStatus) => {
        return Client4.doFetch(
            `${Client4.getUserRoute(userId)}/udf_status`,
            {method: 'put', body: JSON.stringify(udfStatus)}
        );
    }
    deleteUserDefinedStatus = async (userId, udfStatusId) => {
        return Client4.doFetch(
            `${Client4.getUserRoute(userId)}/udf_status/${udfStatusId}`,
            {method: 'delete'}
        );
    }
    updateCustomStatus = async (userId, udfStatusId) => {
        return Client4.doFetch(
            `${Client4.getUserRoute(userId)}/custom_status/${udfStatusId}`,
            {method: 'post'}
        );
    }
    getPaidStats = async (teamId) => {
        return Client4.doFetch(
            `${Client4.getTeamRoute(teamId)}/paid_stat`,
            {method: 'get'}
        );
    }

    uploadWatermarkImage = async (userId, imageData) => {

        const formData = new FormData();
        formData.append('image', imageData);

        const request = {
            method: 'post',
            body: formData
        };

        if (formData.getBoundary) {
            request.headers = {
                'Content-Type': `multipart/form-data; boundary=${formData.getBoundary()}`
            };
        }

        return Client4.doFetch(
            `${Client4.getUserRoute(userId)}/watermark`,
            request
        );
    };

    uploadBackgroundImage = async (userId, imageData) => {

        const formData = new FormData();
        formData.append('image', imageData);

        const request = {
            method: 'post',
            body: formData
        };

        if (formData.getBoundary) {
            request.headers = {
                'Content-Type': `multipart/form-data; boundary=${formData.getBoundary()}`
            };
        }

        return Client4.doFetch(
            `${Client4.getUserRoute(userId)}/background`,
            request
        );
    };

    getProfilesCanJoinTeam = async (teamId, page = 0, perPage = PER_PAGE_DEFAULT) => {
        // this.trackEvent('api', 'api_profiles_get_not_in_team', {team_id: teamId});
        return Client4.doFetch(
            `${Client4.getUsersRoute()}${buildQueryString({allow_added_to_team: teamId, page, per_page: perPage, exclude_web_visitor: true, exclude_inactive: true})}`,
            {method: 'get'}
        );
    };

    getProfilesCanJoinChannel = async (teamId, channelId, page = 0, perPage = PER_PAGE_DEFAULT) => {
        // this.trackEvent('api', 'api_profiles_get_not_in_channel', {team_id: teamId, channel_id: channelId});

        return Client4.doFetch(
            `${Client4.getUsersRoute()}${buildQueryString({in_team: teamId, not_in_channel: channelId, page, per_page: perPage,  exclude_web_visitor: true, exclude_inactive: true})}`,
            {method: 'get'}
        );
    };
    incrementMapUsage = async(userId) => {
        return Client4.doFetch(
            `${Client4.getUserRoute(userId)}/map/usage`,
            {method: 'post'}
        );
    }
    getMaxCallInfo = async(teamId) => {
        return Client4.doFetch(
            `${Client4.getTeamRoute(teamId)}/max_calls_info`,
            {method: 'get'}
        );
    }
    allowPMR = async(teamId) => {
        return Client4.doFetch(
            `${Client4.getTeamRoute(teamId)}/allow_pmr`,
            {method: 'put'}
        );
    }
    denyPMR = async(teamId) => {
        return Client4.doFetch(
            `${Client4.getTeamRoute(teamId)}/deny_pmr`,
            {method: 'put'}
        );
    }
    configPMR = async(team) => {
        return Client4.doFetch(
            `${Client4.getTeamRoute(team.id)}/config_pmr`,
            {method: 'put', body: JSON.stringify(team)}
        );
    }
    sendVerificationSMS = async (login_id) => {
        return Client4.doFetch(
            `${Client4.getUsersRoute()}/sms/verify/send`,
            {method: 'post', body: JSON.stringify({login_id})}
        );
    }
    verifyUserMobile = async (token, login_id) => {
        return Client4.doFetch(
            `${Client4.getUsersRoute()}/mobile/verify`,
            {method: 'post', body: JSON.stringify({token, login_id})}
        );
    }
    
    createVclog = async (vclog) => {
        return Client4.doFetch(
                `${Client4.getUrlVersion()}/vclog`,
            {method: 'post', body: JSON.stringify(vclog)}
        );
    };
    
    getVclog = async (userId) => {
        return Client4.doFetch(
                `${Client4.getUrlVersion()}/vclog/${userId}`,
            {method: 'get'}
        );
    };
    
    sendPasswordResetSMS = async (login_id) => {

        return Client4.doFetch(
            `${Client4.getUsersRoute()}/password/sms/reset/send`,
            {method: 'post', body: JSON.stringify({login_id})}
        );
    }

    sendOnRequestVerificationEmail = async (email, type) => {
        return Client4.doFetch(
            `${Client4.getUsersRoute()}/email/verify/send`,
            {method: 'post', body: JSON.stringify({email, type})}
        );
    }
    getCountryCode = async() => {
        return Client4.doFetch(
            `${Client4.getBaseRoute()}/country`,
            {method: 'get'}
        );
    }
    resetUserPasswordBySMS = async (token, loginId, newPassword) => {
        return Client4.doFetch(
            `${Client4.getUsersRoute()}/password/reset`,
            {method: 'post', body: JSON.stringify({token,login_id: loginId, new_password: newPassword})}
        );
    }


    getUserByCallee = async (callee) => {
        return Client4.doFetch(
            `${Client4.getUsersRoute()}/callee`,
            {method: 'post', body: JSON.stringify(callee)}
        );
    }

    lookupPossibleUsers = async(user) => {
        return Client4.doFetch(
            `${Client4.getUsersRoute()}/lookup/unverified`,
            {method: 'post', body: JSON.stringify(user)}
        )
    }

    getUserCleanUpTime = async(loginId) => {
        return Client4.doFetch(
            `${Client4.getUsersRoute()}/lookup/cleanup${buildQueryString({login_id: loginId})}`,
            {method: 'get'}
        );
    }

    sendEmailInvitesGuestsToTeam = async (teamId, emails) => {
        return Client4.doFetch(
            `${Client4.getTeamRoute(teamId)}/guests/invite/email`,
            {method: 'post', body: JSON.stringify(emails)}
        );
    };
    
    sendMeetingInviteToExternal = async (category, invites) => {
        return Client4.doFetch(
            `${Client4.getUserRoute('me')}/meeting/invite/${(category)}`,
            {method: 'post', body: JSON.stringify(invites)}
        );
    };
    
    uploadChannelImage = async (channelId, imageData) => {

        const formData = new FormData();
        formData.append('image', imageData);

        const request = {
            method: 'post',
            body: formData
        };

        if (formData.getBoundary) {
            request.headers = {
                'Content-Type': `multipart/form-data; boundary=${formData.getBoundary()}`
            };
        }

        return Client4.doFetch(
            `${Client4.getChannelRoute(channelId)}/image`,
            request
        );
    };

    uploadChannelBackgroundImage = async (channelId, imageData) => {

        const formData = new FormData();
        formData.append('image', imageData);

        const request = {
            method: 'post',
            body: formData
        };

        if (formData.getBoundary) {
            request.headers = {
                'Content-Type': `multipart/form-data; boundary=${formData.getBoundary()}`
            };
        }

        return Client4.doFetch(
            `${Client4.getChannelRoute(channelId)}/background`,
            request
        );
    };

    getTeamsWithMemberCount = async (page = 0, perPage = PER_PAGE_DEFAULT, needCount = false) => {

        const query = {page, per_page: perPage};
        if (needCount) {
            query.need_member_count = 'true';
        }

        return Client4.doFetch(
            `${Client4.getTeamsRoute()}${buildQueryString(query)}`,
            {method: 'get'}
        );
    };

    getTeamsStats = async (teamIds) => {
        return Client4.doFetch(
            `${Client4.getTeamsRoute()}/stats`,
            {method: 'post', body: JSON.stringify(teamIds)}
        );
    };

    createChannelWithImages = async (channel, imageData, backgroundData) => {

        const formData = new FormData();
        formData.append('channel', JSON.stringify(channel));

        if (imageData) {
            formData.append('image', imageData);
        }
        if (backgroundData) {
            formData.append('backgroundImage', backgroundData);
        }

        const request = {
            method: 'post',
            body: formData
        };

        if (formData.getBoundary) {
            request.headers = {
                'Content-Type': `multipart/form-data; boundary=${formData.getBoundary()}`
            };
        }

        return Client4.doFetch(
            `${Client4.getChannelsRoute()}/form`,
            request
        );

    }

}

function buildQueryString(parameters) {
    const keys = Object.keys(parameters);
    if (keys.length === 0) {
        return '';
    }

    let query = '?';
    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        query += key + '=' + encodeURIComponent(parameters[key]);

        if (i < keys.length - 1) {
            query += '&';
        }
    }

    return query;
}



// WEBPACK FOOTER //
// ./custom-redux/client/custom_client4.jsx